var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`battery ${_vm.color}`,attrs:{"title":`Battery level: ${_vm.percentFull}%`}},[_c('div',{class:'battery-level ' + _vm.color,style:({ height: `${_vm.percentFull}%` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }